import React from 'react';
import {HomepageSection, HomepageSectionHeader} from '../Homepage';
import ReactHighcharts from 'react-highcharts';
import _ from 'lodash';
import filter from 'App/util/common/filter';
import {process_country} from "../helper";

class IgReplacement extends React.Component {
  render() {
    const options = {
      merge: {
        newValue: 'U',
        values: [null, 'CURR_U', 'U']
      },
      rename: {
        map: {
          'U': 'unknown',
          'SC': 'subcutaneous',
          'IV': 'intravenous',
          'IM': 'intramuscular',
          'PU': 'push',
          'HOME': 'home',
          'HOSP': 'Hospital',
          'OUTPAT': 'Hospital: outpatient',
          'INPAT': 'Hospital: inpatient',
          'OFFICE_OUTPAT': 'Office outpatient',
          'BOTH': 'Home and Hospital'
        }
      }
    };
    const places = process_country("ig_replacement_places");
    const routes = process_country("ig_replacement_routes");
    const ig_replacement_route = filter(this.props.data, 'route', options);
    const ig_replacement_place = filter(this.props.data, 'place', options);
    const reducer = (prev, curr) => ({count: prev.count + curr.count});

    const configIgReplacementRoute = {
      colors: ['#B22222', '#708090', '#9400D3', '#000080', '#9370DB',
        '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
      exporting: {enabled: false},
      chart: {
        type: 'column'
      },
      title: {
        text: 'Ig Replacement'
      },
      subtitle: {
        text: 'routes'
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        title: {
          text: 'number of patients'
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            borderRadius: 2,
            y: -10,
            shape: 'callout'
          }
        }
      },
      tooltip: false,
      series: [
        {
          'name': 'Patients',
          'colorByPoint': true,
          'data':
            _(ig_replacement_route)
              .groupBy('route')
              .map((objs, key) => ({
                  'name': key,
                  'y': objs.reduce(reducer).count + routes[key],
                })
              )
              .orderBy('y', 'desc')
              .value()
        }
      ]
    };
    const configIgReplacementPlace = {
      chart: {
        type: 'column'
      },
      exporting: {enabled: false},
      title: {
        text: 'Ig Replacement'
      },
      subtitle: {
        text: 'place'
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        title: {
          text: 'number of patients'
        }
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            borderRadius: 2,
            y: -10,
            shape: 'callout'
          }
        }
      },
      tooltip: false,

      legend: {
        enabled: false
      },
      series: [
        {
          'name': 'Patients',
          'colorByPoint': true,
          'data':
          // TODO: https://www.highcharts.com/demo/column-drilldown
            _(ig_replacement_place)
              .groupBy('place')
              .map((objs, key) => ({
                  'name': key,
                  'y': objs.reduce(reducer).count+ places[key],
                })
              )
              .orderBy('y', 'desc')
              .value()
        }
      ]
    };

    return (
      <HomepageSection style={{position: 'relative', zIndex: 2}}>
        <HomepageSectionHeader>
          <h2><span>{'Ig Replacement '}</span>
          </h2>
        </HomepageSectionHeader>
        <div className='text-center' style={{marginTop: 25, marginBottom: 25}}>
          <ReactHighcharts config={configIgReplacementRoute}/>
          <ReactHighcharts config={configIgReplacementPlace}/>
        </div>
      </HomepageSection>
    );
  }
}

export default IgReplacement;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/IgReplacement.js